import { status } from 'skin/event/status';

const form = (obj, form, story, data, d, action) => {
	return status.ignore
};

export default form;
